export default __webpack_public_path__ + "static/media/Jerrycan.31796ff2.svg";